import { rowClass } from './utils';
import { IAllCommonCell } from '../../constants/types';
import styles from './index.module.scss';
import HorizontalProgress from '@cp/src/components/ProgressBars/horizontalProgress/HorizontalProgress';
import { convertTimeToMinutes } from '@cp/src/pages/DashboardV2/ActivityTracker/utils';

const AllCommonCell = ({
  isLateLogin,
  isLogoutEarly,
  loginDate,
  logoutDate,
  firstCallDate,
  breakHoursFormat,
  totalMinutes,
  activeMinutes,
  computeClassNames,
  percentage
}: IAllCommonCell) => {
  const correctedPercentage = Math.min(percentage, 100);

  return (
    <div className="flex flex-col">
      <div className={rowClass(isLateLogin)}>{loginDate}</div>
      <div className="w-[100%] h-[1px] bg-greyscale-light" />
      <div className={rowClass(isLogoutEarly)}>{logoutDate || '-'}</div>
      <div className="w-[100%] h-[1px] bg-greyscale-light" />
      <div className={rowClass()}>{firstCallDate || '-'}</div>
      <div className="w-[100%] h-[1px] bg-greyscale-light" />
      <div className={rowClass()}>{breakHoursFormat || '-'}</div>
      <div className="w-[100%] h-[1px] bg-greyscale-light" />
      {!totalMinutes || !activeMinutes ? (
        <div className={styles.progressBarContainer}>
          <HorizontalProgress
            percentage={0}
            className={styles.zeroPercentage}
            percentageClassName={styles.progressColor}
          />
          <div className={styles.timeInHoursAndMinutes}>0 hr 0 min</div>
        </div>
      ) : (
        <div className={styles.progressBarContainer}>
          <HorizontalProgress
            percentage={correctedPercentage}
            className={computeClassNames}
            percentageClassName={styles.progressColor}
          />
          <div className={styles.timeInHoursAndMinutes}>{convertTimeToMinutes(activeMinutes)}</div>
        </div>
      )}
    </div>
  );
};

export default AllCommonCell;
